import React from "react";
import styles from "./Card.module.scss";

const Card = () => {
  return (
    <div className={styles.container}>
      <form>
        <div className={styles.field}>
          <label>
            Current password<span>*</span>
          </label>
          <input type="password" />
        </div>
        <div className={styles.field}>
          <label>
            New password<span>*</span>
          </label>
          <input type="password" />
        </div>
        <div className={styles.field}>
          <label>
            Repeat password<span>*</span>
          </label>
          <input type="password" />
        </div>
        <button type="button">Save changes</button>
      </form>
    </div>
  );
};

export default Card;
